import React, { useState } from "react";
import { useSelector } from "react-redux";
import "../../../styles/payrole-system/payrole-processor.css";
import PaymentLinkTable from "../../payment-link-system/PaymentLinkTable";
import {
  convertStraight,
  convertThenFormat1,
  getMonthYear,
  getMonthYearFromYYMM,
} from "../../common-data/Converts";
import { ReloadIcon } from "../../../images/icons/icons";
import { months, years } from "../../common-data/DropdowData";
import Loader from "../../ui/Loader";

const PayrollHistoryTableView = ({
  allDatas,
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
  callFunction,
  allFilters,
  setAllFilters,
}) => {
  const { payroleHistoryLoading } = useSelector((state) => state.payrole);

  const [activeTab, setActiveTab] = useState("table");

  const columns = [
    {
      dataField: "date",
      text: "Period",
      formatter: (_, row) => (
        <div className="pp-payroll-period-info">
          <svg
            className="pp-payroll-period-icon"
            width="16"
            height="16"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            viewBox="0 0 24 24"
          >
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
            <line x1="16" y1="2" x2="16" y2="6" />
            <line x1="8" y1="2" x2="8" y2="6" />
            <line x1="3" y1="10" x2="21" y2="10" />
          </svg>
          <span className="pp-payroll-period-text">
            {getMonthYear(row?.date)}
          </span>
        </div>
      ),
    },
    {
      dataField: "employer_count",
      text: "Employees Count",
      formatter: (_, row) => (
        <span className="tb-data">
          {Math.round(Number(row?.employer_count || 0))}
        </span>
      ),
    },
    {
      dataField: "total_payout",
      text: "Total Payout",
      formatter: (_, row) => (
        <div className="pp-payroll-payout-info">
          <span className="tb-data">
            ₹{convertThenFormat1(row?.total_payout || 0)}
          </span>
        </div>
      ),
    },
    {
      dataField: "deductions",
      text: "Deductions",
      formatter: (_, row) => (
        <span className="pp-payroll-deductions tb-data">
          {" "}
          ₹{convertThenFormat1(row?.deduction || 0)}
        </span>
      ),
    },
    {
      dataField: "avgAttendance",
      text: "Avg Attendance",
      formatter: (_, row) => (
        <span className="tb-data">
          {" "}
          {Math.round(Number(row?.avg_attendance || 0))}
        </span>
      ),
    },
    {
      dataField: "status",
      text: "Status",
      formatter: (_, row) => (
        <span
          className={
            row.status === "processed"
              ? "pp-employee-payroll-badge pp-green-badge"
              : "pp-employee-payroll-badge pp-yellow-badge"
          }
        >
          {row.status}
        </span>
      ),
    },
    {
      dataField: "processed_date",
      text: "Processed Date",
      formatter: (_, row) => (
        <span className="tb-data">{convertStraight(row?.processed_date)}</span>
      ),
    },
  ];

  return (
    <div className="pp-discrepancy-table-container">
      <div className="pp-payroll-history-header-row">
        <div className="pp-employee-payroll-card-header">
          <span>Payroll History</span>
          <button variant="dark" type="button" onClick={callFunction}>
            <ReloadIcon />
          </button>
        </div>

        <div className="pp-payroll-history-filter-group">
          <select
            className="pp-payroll-history-select"
            value={allFilters.selectedYear?.value || ""}
            onChange={(e) => {
              const selectedYearObj = years.find(
                (year) => year.value === e.target.value
              );
              setAllFilters((prevs) => ({
                ...prevs,
                selectedYear: selectedYearObj || null,
              }));
            }}
          >
            <option value="">Select Year</option>
            {years.map((year) => (
              <option key={year?.value} value={year?.value}>
                {year?.label}
              </option>
            ))}
          </select>
          <select
            className="pp-payroll-history-select"
            value={allFilters.selectedMonth?.value || ""}
            onChange={(e) => {
              const selectedMonthObj = months.find(
                (month) => month.value === e.target.value
              );
              setAllFilters((prevs) => ({
                ...prevs,
                selectedMonth: selectedMonthObj || null,
              }));
            }}
          >
            <option value="">Select Month</option>
            {months.map((month) => (
              <option key={month?.value} value={month?.value}>
                {month?.label}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="pp-tab-toggle">
        <button
          className={`pp-tab-toggle-btn ${
            activeTab === "table"
              ? "pp-tab-toggle-active"
              : "pp-tab-toggle-inactive"
          }`}
          onClick={() => setActiveTab("table")}
        >
          Table View
        </button>
        <button
          className={`pp-tab-toggle-btn ${
            activeTab === "trends"
              ? "pp-tab-toggle-active"
              : "pp-tab-toggle-inactive"
          }`}
          onClick={() => setActiveTab("trends")}
        >
          Trends
        </button>
      </div>

      <div className="pp-discrepancy-table-wrapper">
        {activeTab === "trends" ? (
          <div className="pp-payroll-trends-grid mt30">
            <div className="pp-payroll-trends-card">
              <div className="pp-payroll-trends-title">Payout Trends</div>
              {allDatas.trendData?.map((row, idx) => (
                <div className="pp-payroll-trends-row" key={idx}>
                  <span className="pp-payroll-trends-month">
                    {getMonthYearFromYYMM(row?.year_month)}
                  </span>
                  <span className="pp-payroll-trends-payout">
                    ₹{convertThenFormat1(row?.total_payout || 0)}
                  </span>
                </div>
              ))}
            </div>

            <div className="pp-payroll-trends-card">
              <div className="pp-payroll-trends-title">Employee Count</div>
              {allDatas.trendData?.map((row, idx) => (
                <div className="pp-payroll-trends-row" key={idx}>
                  <span className="pp-payroll-trends-month">
                    {getMonthYearFromYYMM(row?.year_month)}
                  </span>
                  <span className="pp-payroll-trends-empcount">
                    {Math.round(Number(row?.employer_count || 0))}
                  </span>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <div className="pp-employee-payroll-table-wrapper mt30">
            {payroleHistoryLoading ? (
              <Loader />
            ) : (
              <PaymentLinkTable
                tableData={allDatas.allData}
                tableColumns={columns}
                tablePagination={allDatas.pagination}
                isPage={isPage}
                setIsPage={(value) => setIsPage(value)}
                pageLimit={pageLimit}
                setPageLimit={setPageLimit}
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default PayrollHistoryTableView;
